import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Breadcrums from "../../../common/breadcrumbs";
import { capitalizeFirstLetter, formateDateWithMonth } from "../../../../../utils/commonfunction";
import CustomPagination from "../../../common/custompagination";
import Sorting from "../../../common/sorting";
import * as reportService from "../../../services/reports.service";
import { useTranslation } from "react-i18next";
import { Placeholder, Tooltip, Whisper } from "rsuite";

const RevenueReportList = () => {
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState();
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard" },
    { title: "Revenue Report", url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", globalsearch);
        reportService
          .ListRevenuereport(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list ? data.data.list : []);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);

    return () => clearTimeout(getData);
  }, [location, sorting, search, params.pgno, globalsearch]);

  const viewfunction = (row) => {
    navigate(`/admin/reports/revenue-reports/view/${row._id}`);
  };

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card overflow-hidden">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">Revenue Report</h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("Search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            {
              loader?
              <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              :
              <>
            <div className="table-responsive min-h-400">
              <table id="example-input" className="table table-bordered card-table border-top text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="sr_head">{t("admin.faq.list_heading_sno")}</th>
                    <th>
                      <div className="sorting_column">
                        <span>User Name</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="user_name" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>User Email</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="user_email" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Amount</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="amount" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Status</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="staus" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>Reference ID</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="points" />
                      </div>
                    </th>
                    <th>
                      <div className="sorting_column">
                        <span>{t("Created Date")}</span>
                        <Sorting sort={sorting} handleSort={handleSort} column="created_at" />
                      </div>
                    </th>
                    <th className="action_head">{t("Action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {loader ? (
                    <tr>
                      <td colSpan={13}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <> */}
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                              <td>{row?.user ? capitalizeFirstLetter(row.user.role === 'business' ? row.user?.business_name : row?.user.fullName) : "N/A"}</td>
                              <td>{row?.user?.email ? row?.user?.email : "N/A"}</td>
                              <td>{row?.totalAmount ? `${row.currency}${row.totalAmount}` : "N/A"}</td>
                              <td>{row?.status ? row?.status : "N/A"}</td>
                              <td>{row?.transactionID ? row?.transactionID : "N/A"}</td>
                              <td>{row?.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                              <td>
                                <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                  <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: "bold" }}>View</Tooltip>}>
                                      <button
                                        type="button"
                                        className="btn view"
                                        onClick={() => {
                                          viewfunction(row);
                                        }}>
                                        <i className="ri-eye-fill"></i>
                                      </button>
                                    </Whisper>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={13} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    {/* </>
                  )} */}
                </tbody>
              </table>
            </div>
            <div className="" id="example1_info" role="status" aria-live="polite">
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination datalength={datalength} itemperpage={itemperpage} setPage={setPage} currentPage={page} pageRoute={[{ name: "PageTable", path: "/admin/reports/revenue-reports/list" }]} />
            ) : (
              ""
            )}
              </>
             }
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default RevenueReportList;
